import { Spin, Typography } from "antd";

const { Text } = Typography;

/** Sidebar card shown in place of the empty state while a first EHR pull is outstanding. */
export default function PatientSyncNotice() {
  return (
    <div
      style={{
        margin: "24px 12px",
        padding: "20px 18px",
        borderRadius: 12,
        background: "#f8f7ff",
        border: "1px solid #ece9ff",
        textAlign: "left",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
        <Spin size="small" />
        <Text style={{ fontSize: 15, fontWeight: 600, color: "#4338ca" }}>Setting up your patient list</Text>
      </div>
      <Text type="secondary" style={{ fontSize: 13, display: "block", lineHeight: 1.6 }}>
        We're pulling today's schedule from your EHR. This usually takes a few minutes, and your patients will appear
        here automatically.
      </Text>
      <Text type="secondary" style={{ fontSize: 13, display: "block", lineHeight: 1.6, marginTop: 8 }}>
        You can add a patient manually any time.
      </Text>
    </div>
  );
}
